var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "category__produkt--bilder",
      attrs: { href: _vm.itemUrl, title: _vm.titleText },
    },
    [
      _vm.lazyImages
        ? _c(
            "div",
            {
              staticClass: "category__produkt--bilder-container",
              on: {
                mouseover: function ($event) {
                  _vm.twoImages.length > 1 ? _vm.setupHover($event, true) : null
                },
                mouseleave: function ($event) {
                  _vm.twoImages.length > 1
                    ? _vm.setupHover($event, false)
                    : null
                },
              },
            },
            _vm._l(_vm.twoImages, function (imageUrl, index) {
              return _c("lazy-category-img", {
                key: index,
                class: [_vm.onHover ? "active" : "", "img-fluid"],
                attrs: {
                  imageUrl: imageUrl.url,
                  alt: _vm.getAltText(imageUrl),
                  title: _vm.getAltText(imageUrl),
                },
              })
            }),
            1
          )
        : _c(
            "div",
            {
              staticClass: "category__produkt--bilder-container",
              on: {
                mouseover: function ($event) {
                  _vm.twoImages.length > 1 ? _vm.setupHover($event, true) : null
                },
                mouseleave: function ($event) {
                  _vm.twoImages.length > 1
                    ? _vm.setupHover($event, false)
                    : null
                },
              },
            },
            _vm._l(_vm.twoImages, function (imageUrl, index) {
              return _c("img", {
                key: index,
                class: [_vm.onHover ? "active" : "", "img-fluid"],
                attrs: {
                  src: imageUrl.url,
                  alt: _vm.getAltText(imageUrl),
                  title: _vm.getAltText(imageUrl),
                },
              })
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }